import Frame2 from "../assets/frame2.png"
import Credit from "../assets/credit.png"
import Interest from "../assets/interest.png"
import Bankcard from "../assets/bankcard.png"
import Moneytimer from "../assets/moneytimer.png"
import Steering from "../assets/steering.png"
import Box from "../assets/box.png"
import Tag1 from "../assets/tag1.png"
import Tag2 from "../assets/tag2.png"
import Tag3 from "../assets/tag3.png"
import Tag4 from "../assets/tag4.png"
import Gplay from "../assets/gplay.png"
import Appplay from "../assets/appplay.png"
import Frame3 from "../assets/frame3.png"
import Background from "../assets/Background.png"
import Bgscreen from "../assets/bgscreen.png"
import Img1 from "../assets/img1.png"
import Img2 from "../assets/img2.png"
import Img3 from "../assets/img3.png"
import Rec from "../assets/rec.png"
import Frm from '../assets/frm.png'
import Frm2 from '../assets/frm2.png'
import Frm1 from '../assets/frm1.png'
import Long from '../assets/long.png'
import Phone1 from '../assets/phone1.png'
import Iphonedata from '../assets/iphonedata.png'
import Card from '../assets/card.png'
import Person from '../assets/person.png'
import Female from '../assets/female.png'
import Femalefull from '../assets/femalefull.png'
import Tosave from '../assets/tosave.png'
import Vault from '../assets/vault.png'
import Goals from '../assets/goals.png'
import Group from '../assets/group.png'


export const group = Group
export const goals = Goals
export const vault = Vault
export const tosave = Tosave
export const femalefull = Femalefull
export const female = Female
export const person = Person
export const long = Long
export const frm = Frm
export const rec = Rec
export const frm2 = Frm2
export const frm1 = Frm1
export const frame2 = Frame2
export const credit = Credit
export const interest = Interest
export const bankcard = Bankcard
export const moneytimer = Moneytimer
export const steering = Steering
export const box = Box
export const tag1 = Tag1
export const tag2 = Tag2
export const tag3 = Tag3
export const tag4 = Tag4
export const gplay = Gplay
export const appplay = Appplay
export const frame3 = Frame3
export const background = Background
export const bgscreen = Bgscreen
export const img1 = Img1
export const img2 = Img2
export const img3 = Img3
export const phone1 = Phone1
export const iphonedata = Iphonedata
export const card = Card
